var $ = require( "jquery" )

$(document).ready( function(){
  if( $('#event_limited_spots_1').prop( "checked" ) ){
    $('#number_of_spots_selection').show();
  }
  else{
    $('#number_of_spots_selection').hide();
  }

  $('input[name="event[limited_spots]"').change( function(){
    if( $(this).val() == '1' ){
      $('#number_of_spots_selection').show();
    }
    else{
      $('#number_of_spots_selection').hide();
    }
  });
});
